
export const ElfNameGeneratorTheme = {
  // Container
  container: "bg-gradient-to-br from-elfPink-light to-elfGreen-light rounded-xl p-5 shadow-md",
  
  // Header
  header: "flex items-center justify-center mb-5",
  headerIcon: "text-elfRed-dark h-6 w-6 mr-2",
  title: "text-2xl font-display font-bold text-center text-foreground",
  
  // Content
  content: "space-y-6",
  
  // Form
  form: "space-y-4",
  formGroup: "flex items-center justify-center space-x-4",
  radioGroup: "flex items-center space-x-6",
  radioLabel: "flex items-center cursor-pointer",
  radioInput: "mr-2 h-4 w-4 cursor-pointer accent-elfRed",
  radioText: "text-gray-700",
  generateButton: "w-full bg-elfRed hover:bg-elfRed-dark text-white font-semibold py-2.5 px-4 rounded-lg flex items-center justify-center transition-colors duration-300",
  loadingIcon: "animate-spin mr-2 h-4 w-4",
  
  // Generated Name
  nameContainer: "bg-white/80 rounded-lg p-5 text-center animate-fade-in shadow-sm",
  namePrefix: "text-gray-500 text-sm mb-1",
  nameDisplay: "text-3xl font-display font-bold text-elfGreen-dark mb-3",
  nameActions: "flex justify-center space-x-3 mt-4",
  actionButton: "bg-elfYellow hover:bg-elfYellow-dark text-gray-800 py-1.5 px-3 rounded-lg text-sm flex items-center transition-colors duration-300",
  actionIcon: "h-4 w-4 mr-1.5",
  
  // History
  historyContainer: "mt-6 bg-white/70 rounded-lg p-4",
  historyHeader: "flex justify-between items-center mb-3",
  historyTitle: "font-semibold text-gray-700",
  historyClearButton: "text-xs text-gray-500 hover:text-gray-700",
  historyList: "space-y-2 max-h-40 overflow-y-auto pr-1",
  historyItem: "text-sm py-1.5 px-3 rounded-md hover:bg-elfGreen-light/50 cursor-pointer transition-colors flex justify-between items-center",
  historyName: "font-medium text-gray-700",
  historyTimestamp: "text-xs text-gray-500",
  
  // Animations
  fadeIn: "animate-fade-in",
  scaleIn: "animate-scale-in",
  sparkleIcon: "text-elfYellow-dark animate-pulse"
};
